import { createListenerMiddleware } from '@reduxjs/toolkit';
import { toastActions } from 'src/store/client/slices/toastSlice';
import { userActions } from 'src/store/client/slices/userSlice';
import { saveUsername } from 'src/utils/usernameStorage';

// Create the listener middleware instance
export const loginToastListenerMiddleware = createListenerMiddleware();

// Listen for login action to show toast for non-SNS login
loginToastListenerMiddleware.startListening({
  actionCreator: userActions.login,
  effect: async (action, listenerApi) => {
    // 로그인 성공 시 임시 저장된 username 정보 확인 및 저장
    const pendingData = (window as Window & { __pendingUsernameToSave?: { shouldSave: boolean; usernameType: string; username: string } | null }).__pendingUsernameToSave;
    if (pendingData && pendingData.shouldSave) {
      saveUsername(pendingData.usernameType as 'phone' | 'email' | 'lpoint', pendingData.username);
      // 저장 후 임시 데이터 제거
      (window as Window & { __pendingUsernameToSave?: { shouldSave: boolean; usernameType: string; username: string } | null }).__pendingUsernameToSave = null;
    }

    // 로그인 버튼 클릭으로 로그인한 경우에만 토스트 표시
    const isLoginFromButton = sessionStorage.getItem('loginAttemptFromButton') === 'true';
    if (!isLoginFromButton) {
      return;
    }

    // 사용된 플래그 제거
    sessionStorage.removeItem('loginAttemptFromButton');

    // JWT 토큰에서 로그인 타입 확인하여 토스트 표시
    try {
      const { parseJwt } = await import('src/utils/auth');
      const tokenInformation = parseJwt(action.payload.access_token);

      if (tokenInformation) {
        const loginType = tokenInformation.tokenUserLoginType;

        // L(엘포인트), B(이메일), P(휴대폰) 로그인 시 SNS 연동 안내 토스트 표시
        if (loginType === 'L' || loginType === 'B' || loginType === 'P') {
          listenerApi.dispatch(
            toastActions.showToast({
              message: ['로그인되었습니다.마이페이지에서', '구글·카카오 연동 시 더 편리하게 이용 가능합니다.'],
              options: {
                timeout: 1000,
                hideCloseButton: true,
              },
            }),
          );
        }
      }
    } catch (error) {
      console.warn('Failed to parse JWT token for toast:', error);
    }
  },
});
